export default __webpack_public_path__ + "static/media/travel-care-6.1deddae3.svg";